import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
// This file only serves as a styles wrapper for the imported styles from the react-date-range library. No need to tweak unless needed to tweak specifics from that library.
var DatePickerWrapper = function (_a) {
    var children = _a.children;
    return _jsx(_Fragment, { children: children });
};
export default DatePickerWrapper;
